import { optionsFunction } from "./_config";
import axios from "axios";
export const getActiveEvents = () =>
  axios
    .get(`/api/v2/event/active`, optionsFunction())
    .then((res) => res.data.data);

export const getAllEvents = () =>
  axios
    .get(`/api/v2/event/all`, optionsFunction())
    .then((res) => res.data.data);

export const getEventById = (event) =>
  axios
    .get(`/api/v2/event/${encodeURIComponent(event)}`, optionsFunction())
    .then((res) => res.data.data);

// Only for events with `opt_in: true`. Debits `opt_in_cost`; nothing is
// counted for the player before this call.
export const optInToEvent = (event) =>
  axios
    .post(
      `/api/v2/event/${encodeURIComponent(event)}/opt-in`,
      {},
      optionsFunction()
    )
    .then((res) => res.data.data);
export const upgradeEventToPremium = (event) =>
  axios
    .post(
      `/api/v2/event/${encodeURIComponent(event)}/premium`,
      {},
      optionsFunction()
    )
    .then((res) => res.data.data);

export const claimEventRewards = (event) =>
  axios
    .post(
      `/api/v2/event/${encodeURIComponent(event)}/claim`,
      {},
      optionsFunction()
    )
    .then((res) => res.data.data);

export const markEventSeen = (event) =>
  axios
    .post(
      `/api/v2/event/${encodeURIComponent(event)}/seen`,
      {},
      optionsFunction()
    )
    .then((res) => res.data.data);

// Error ids returned as `err.data.id` on a 422. Each doubles as a
// translation key.
export const EVENT_ERROR = Object.freeze({
  OPT_IN_NOT_REQUIRED: "event.error.opt_in_not_required",
  ALREADY_OPTED_IN: "event.error.already_opted_in",
  NOT_OPTED_IN: "event.error.not_opted_in",
  NOT_APPLICABLE: "event.error.not_applicable",
  NOT_COMPLETED: "event.error.not_completed",
  ALREADY_CLAIMED: "event.error.already_claimed",
  PREMIUM_NOT_PURCHASABLE: "event.error.premium_not_purchasable",
  NOT_ENOUGH_CURRENCY: "general.error.not_enough_currency",
});
